module.exports = __webpack_public_path__ + "svg/dice.svg?1480df004df36aadf5824344beaca01c";